module.exports = __webpack_public_path__ + "static/media/13ITC2.79b90d7c.jpg";